import * as tslib_1 from "tslib";
import removeRowsFromListViewStore from '../actions/triage/removeRowsFromListViewStore';
import removeSingleItemFromConversation from '../mutators/removeSingleItemFromConversationMutator';
import getAllTableViewsContainingItems from '../utils/getAllTableViewsContainingItems';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import tombstoneOperations from 'owa-mail-list-tombstone';
import { orchestrator } from 'satcheljs';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
export default orchestrator(deleteItemsStoreUpdate, function (actionMessage) {
    var e_1, _a;
    var firstItemContext = actionMessage.itemContexts[0];
    var tableViews = getAllTableViewsContainingItems(firstItemContext && firstItemContext.mailboxInfo, actionMessage.parentFolderId, true /* shouldIncludeSearchTable */);
    try {
        for (var tableViews_1 = tslib_1.__values(tableViews), tableViews_1_1 = tableViews_1.next(); !tableViews_1_1.done; tableViews_1_1 = tableViews_1.next()) {
            var tableView = tableViews_1_1.value;
            if (tableView.tableQuery.listViewType == 1 /* Message */) {
                removeItemsInMessageTable(actionMessage.itemContexts, tableView);
            }
            else if (tableView.tableQuery.listViewType == 0 /* Conversation */) {
                removeItemsInConversationTable(actionMessage.itemContexts, tableView);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tableViews_1_1 && !tableViews_1_1.done && (_a = tableViews_1.return)) _a.call(tableViews_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
});
function removeItemsInMessageTable(itemContexts, tableView) {
    var rowIds = itemContexts.map(function (itemContext) {
        return itemContext.itemId;
    });
    var rowKeys = getRowKeysFromRowIds(rowIds, tableView);
    // Filter to items that exist in this particular table
    var filteredRowKeys = rowKeys.filter(function (rowKey) { return tableView.rowKeys.indexOf(rowKey) >= 0; });
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }
    removeRowsFromListViewStore(filteredRowKeys, tableView);
    // Add deleted instanceKeys to tombstones so they don't pop back in
    addRowKeysToTombstone(tableView, rowKeys);
}
function removeItemsInConversationTable(itemContexts, tableView) {
    var e_2, _a, e_3, _b;
    try {
        for (var itemContexts_1 = tslib_1.__values(itemContexts), itemContexts_1_1 = itemContexts_1.next(); !itemContexts_1_1.done; itemContexts_1_1 = itemContexts_1.next()) {
            var itemContext = itemContexts_1_1.value;
            var conversationRowKeys = getRowKeysFromRowIds([itemContext.conversationId], tableView);
            try {
                for (var conversationRowKeys_1 = tslib_1.__values(conversationRowKeys), conversationRowKeys_1_1 = conversationRowKeys_1.next(); !conversationRowKeys_1_1.done; conversationRowKeys_1_1 = conversationRowKeys_1.next()) {
                    var conversationRowKey = conversationRowKeys_1_1.value;
                    var tableConversationRelation = getTableConversationRelation(conversationRowKey, tableView.id);
                    if (!tableConversationRelation) {
                        // This item was not found in the current table, noop
                        continue;
                    }
                    if (tableConversationRelation.itemIds.length == 1 &&
                        tableConversationRelation.itemIds[0] == itemContext.itemId) {
                        // Removing the last item in the conversation, we need to remove the entire conversation row
                        removeRowsFromListViewStore([conversationRowKey], tableView);
                        // Add deleted instanceKeys to tombstones so they don't pop back in
                        addRowKeysToTombstone(tableView, [conversationRowKey]);
                    }
                    else {
                        removeSingleItemFromConversation(itemContext, tableView.id);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (conversationRowKeys_1_1 && !conversationRowKeys_1_1.done && (_b = conversationRowKeys_1.return)) _b.call(conversationRowKeys_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (itemContexts_1_1 && !itemContexts_1_1.done && (_a = itemContexts_1.return)) _a.call(itemContexts_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
function addRowKeysToTombstone(tableView, rowKeys) {
    // Add deleted instanceKeys to tombstones so they don't pop back in
    // Only need to do this for mail folder and group queries which supports notifications and pin(folderOnly)/delete actions
    if (tableView.tableQuery.type === 0 /* Folder */ ||
        tableView.tableQuery.type === 2 /* Group */) {
        tombstoneOperations.add(rowKeys, tableView.serverFolderId, {
            type: 0 /* OnDeleteNotification */,
        });
    }
}
//# sourceMappingURL=deleteItemsStoreUpdateOrchestrator.js.map